import {
  darken,
  getContrastRatio,
  lighten,
} from '@mui/system/colorManipulator';

/** Darken or lighten `color` until contrast vs `background` reaches `minRatio`. */
export function adjustUntilMinContrast(
  color: string,
  background: string,
  minRatio = 3
): string {
  let result = color;
  let ratio = getContrastRatio(result, background);
  if (ratio >= minRatio) {
    return result;
  }

  const darkened = darken(result, 0.05);
  const lightened = lighten(result, 0.05);
  const step =
    getContrastRatio(darkened, background) >=
    getContrastRatio(lightened, background)
      ? darken
      : lighten;

  for (let i = 0; i < 50 && ratio < minRatio; i++) {
    const next = step(result, 0.05);
    const nextRatio = getContrastRatio(next, background);
    if (nextRatio <= ratio) {
      break;
    }
    result = next;
    ratio = nextRatio;
  }

  return result;
}
